import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({

  onrenderColumnStack: {
    height: 25,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
 
  textAlignEnd: {
    textAlign: 'end',
  },
  columnHeight: {
    height: 25,
  },
  listContainer:{
    marginLeft: 48
  }
}));
